import { ENV_VARS } from 'constants/environment.constants';
import { kf1AuthenticatedHttpClient } from 'kfone-frontend-core';
import { useSettingsStore } from 'store';

const PAYSIGN_GAP_API = 'overview/paygapsettings';

// Common response handler for settings API
export const handleSettingsResponse = (response: any): boolean => {
  if (response?.data?.responseCode === 200) {
    const { data } = response.data;
    const { updatePayGapsPositive } = useSettingsStore.getState();
    updatePayGapsPositive(
      data.payGapFlag,
      data.signThreshold,
      data.targetPayGap,
      data.maxIncrement,
    );
    return true;
  }
  return false;
};

export const getPaySignGap = async () => {
  const config = {
    baseURL: ENV_VARS.API_URL,
    url: PAYSIGN_GAP_API,
    method: 'GET',
  };
  return kf1AuthenticatedHttpClient(config);
};

interface UpdateSettingsParams {
  pay_gap_flag?: boolean;
  sign_threshold?: string;
  target_pay_gap?: string;
  max_increment?: string;
}

export const updateSettings = async (params: UpdateSettingsParams) => {
  // Get current values from store
  const { isPayGapsPositive, signThreshold, targetPayGap, maxIncrement } =
    useSettingsStore.getState();

  // Merge passed values with store values
  const data = {
    pay_gap_flag: params.pay_gap_flag ?? isPayGapsPositive ?? true,
    sign_threshold: params.sign_threshold ?? signThreshold,
    target_pay_gap: params.target_pay_gap ?? targetPayGap,
    max_increment: params.max_increment ?? maxIncrement,
  };

  const config = {
    baseURL: ENV_VARS.API_URL,
    url: PAYSIGN_GAP_API,
    method: 'PUT',
    data,
  };

  return kf1AuthenticatedHttpClient(config);
};

